const user_model = {
    about: null,
    address: {
        country: null,
        street: null,
        city: null,
        region: null,
        number: null,
        building: null,
        postal_code: null,
    },
    avatar: null,
    birthdate: {
        day: null,
        month: null,
        year: null
    },
    email: '',
    password: '',
    password_confirmation: '',
    first_name: '',
    full_name: null,
    gender: null,
    last_name: null,
    logged_at: null,
    nickname: null,
    organization: {
        id: null,
        name: null,
        type: null
    },
    organization_id: '',
    phone: null,
    timezone: null,
    title: null,
    website: null,
    social: {
        facebook: null,
        google_plus: null,
        twitter: null,
        linkedin: null,
        youtube: null,
        instagram: null,
        pinterest: null,
        tumblr: null
    }
};
const organization_model = {
    about: '',
    address: {
        country: '',
        street: '',
        city: '',
        region: '',
        number: '',
        building: '',
        postal_code: '',
    },
    contact: {
        name: '',
        email: '',
        phone: '',
        position: ''
    },
    avatar: '',
    created_at: '',
    email: '',
    name: '',
    logged_at: '',
    parent_id: '',
    phone: '',
    timezone: '',
    website: '',
    social: {
        facebook: '',
        google_plus: '',
        twitter: '',
        linkedin: '',
        youtube: '',
        instagram: '',
        pinterest: '',
        tumblr: ''
    }
};
const billing_model = {
    name: null,
    type: null,
    fiscal_code: null,
    registry_number: null,
    banks: [{
        name: null,
        account: null,
        currency: null,
    }],
    contact: {
        name: null,
        email: null,
        phone: null,
        position: null,
    },
    address: {
        country: null,
        state: null,
        city: null,
        street: null,
        number: null,
        building: null,
        postal_code: null,
    }
};
const service_model = {
    color: '',
    slug: '',
    name: '',
    description: ''
};
const event_model = {
  id: '',
  listeners: [],
  service: '',
  slug: ''
};
const listener_model = {
  events: [],
  id: '',
  path: '',
  service: ''
};

export default {
    'user_item': user_model,
    'service_item': service_model,
    'event_item': event_model,
    'organization_item': organization_model,
    'listener_item': listener_model,
    'billing_item': billing_model,
};
